import { ReactNode } from 'react';
import '../../../styles/edit-object-design.css';

interface EditObjectShellProps {
  /** Density override — defaults to "comfortable" per design. */
  density?: 'comfortable' | 'compact';
  /** Sidebar collapse override — defaults to expanded. */
  sidebarCollapsed?: boolean;
  children: ReactNode;
}

/**
 * Root container for the /edit-object page tree. Owns the
 * `.ali-edit-object` scope so the design's CSS in
 * `frontend/src/styles/edit-object-design.css` only applies inside.
 *
 * The CSS file is imported here (once) so any caller automatically pulls it
 * into the bundle — no need for App.tsx to import it.
 */
export const EditObjectShell = ({
  density = 'comfortable',
  sidebarCollapsed = false,
  children,
}: EditObjectShellProps) => (
  <div
    className="ali-edit-object"
    data-density={density}
    data-sidebar={sidebarCollapsed ? 'collapsed' : 'expanded'}
  >
    <div className="container">{children}</div>
  </div>
);

interface LayoutProps {
  children: ReactNode;
}
export const Layout = ({ children }: LayoutProps) => <div className="layout">{children}</div>;
